var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "podcast-settings-popup",
      class: { "dark-theme": _vm.isDarkMode },
    },
    [
      _c("div", { staticClass: "podcast-container" }, [
        _c("div", { staticClass: "go-panel-body" }, [
          _c("div", { staticClass: "pod-cast-wrap" }, [
            _c("div", { staticClass: "title-text" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("briefing.recap.podcastSettings.chooseAHost")
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pod-cast-select" }, [
              _c("div", { staticClass: "host-navigation" }, [
                _c(
                  "div",
                  { staticClass: "hosts-container" },
                  _vm._l(_vm.visibleHosts, function (host) {
                    return _c("dl", { key: host.narratorId }, [
                      _c("dt", [
                        _c(
                          "div",
                          {
                            staticClass: "go-user-thumb",
                            class: { "disabled-thumb": !_vm.podcastEnabled },
                          },
                          [
                            _c("img", {
                              class: { "disabled-image": !_vm.podcastEnabled },
                              attrs: { src: host.narratorImg },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "go-user-name",
                            class: { "disabled-text": !_vm.podcastEnabled },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(host.narratorName) +
                                "\n                  "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c(
                          "div",
                          { staticClass: "custom-control custom-radio" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedHost,
                                  expression: "selectedHost",
                                },
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                id: "modelCheck" + host.narratorId,
                                disabled: !_vm.podcastEnabled,
                              },
                              domProps: {
                                value: host.narratorId,
                                checked: _vm._q(
                                  _vm.selectedHost,
                                  host.narratorId
                                ),
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    _vm.selectedHost = host.narratorId
                                  },
                                  function ($event) {
                                    return _vm.onHostSelected(host.narratorId)
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              class: { "disabled-label": !_vm.podcastEnabled },
                              attrs: { for: "modelCheck" + host.narratorId },
                            }),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "text",
                class: { "disabled-text": !_vm.podcastEnabled },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.currentHostDescription) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pod-cast-player" }, [
              _c("div", { staticClass: "pod-cast-player-range" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.playerProgress,
                      expression: "playerProgress",
                    },
                  ],
                  staticClass: "go-form-range",
                  attrs: {
                    type: "range",
                    id: "customRange",
                    disabled: !_vm.podcastEnabled,
                    max: "100",
                  },
                  domProps: { value: _vm.playerProgress },
                  on: {
                    input: _vm.onProgressChange,
                    __r: function ($event) {
                      _vm.playerProgress = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "time-audio",
                    class: { "disabled-text": !_vm.podcastEnabled },
                  },
                  [
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatTime(_vm.currentTime))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatTime(_vm.totalTime))),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      class: { active: _vm.isPlaying },
                      staticStyle: { "background-color": "#6c757d21" },
                      attrs: { type: "button", disabled: !_vm.podcastEnabled },
                      on: { click: _vm.togglePlay },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-24",
                        class: _vm.isPlaying
                          ? "go-icon-player-pause-filled"
                          : "go-icon-player-play-filled",
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button", disabled: !_vm.podcastEnabled },
                      on: { click: _vm.toggleMute },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-24",
                        class: _vm.isMuted
                          ? "go-icon-volume-off"
                          : "go-icon-volume",
                      }),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pod-cast-create" }, [
          _c(
            "button",
            {
              staticClass: "btn go-btn-default btn-gen-podcast",
              attrs: { type: "button", disabled: _vm.isGenerated },
              on: { click: _vm.generate },
            },
            [
              _c("i", { staticClass: "go-icon-24 go-icon-headphones" }),
              _vm._v(" "),
              _c("em", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("briefing.recap.podcastSettings.createPodcastNow")
                  ),
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "go-info-title" }, [
            _c("i", { staticClass: "go-icon-16 go-icon-alert-circle" }),
            _vm._v(" "),
            _c("span", {
              staticClass: "go-form-feedback-help",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "briefing.recap.podcastSettings.podcastSystemNotification"
                  )
                ),
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }